import { IApplicationState } from '../../types/redux';

export const getIsBrokerAvailable = (state: IApplicationState): boolean => {
  return state.newbuilding.newbuildingBroker?.isAvailable || false;
};
